/* PawsOn 2026 — header behaviour.
 *
 * Mega menus open on hover per the design, but hover alone strands keyboard
 * and touch users, so focus and click open them too. Only one panel is ever
 * open; Escape closes and returns focus to its trigger.
 */
(function () {
  'use strict';

  function initNav(nav) {
    if (nav.dataset.pwNavReady) return;
    nav.dataset.pwNavReady = 'true';

    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-pw-item]'));
    if (!items.length) return;

    var openItem = null;
    var closeTimer = null;

    function setOpen(item, open) {
      var trigger = item.querySelector('[data-pw-trigger]');
      var panel = item.querySelector('[data-pw-panel]');
      if (!trigger || !panel) return;

      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      openItem = open ? item : openItem === item ? null : openItem;
    }

    function closeAll() {
      items.forEach(function (item) {
        setOpen(item, false);
      });
      openItem = null;
    }

    function open(item) {
      window.clearTimeout(closeTimer);
      if (openItem && openItem !== item) setOpen(openItem, false);
      setOpen(item, true);
    }

    /* A small delay stops the panel flickering shut when the pointer crosses
       the gap between the trigger and the panel below it. */
    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAll, 120);
    }

    /* Tile images are lazy inside a hidden panel, so nothing fetches until the
       first hover and the tile flashes empty. Warm them when the pointer first
       reaches the nav — earlier than any single item, still not on page load. */
    nav.addEventListener(
      'pointerenter',
      function () {
        nav.querySelectorAll('.pw-mega__tile-img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      },
      { once: true }
    );

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-pw-trigger]');

      item.addEventListener('mouseenter', function () {
        open(item);
      });
      item.addEventListener('mouseleave', scheduleClose);

      item.addEventListener('focusin', function () {
        open(item);
      });

      /* On touch, the first tap opens the panel rather than following the
         parent link; a second tap on the same trigger navigates. */
      if (trigger) {
        trigger.addEventListener('click', function (event) {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (!isOpen) {
            event.preventDefault();
            open(item);
          }
        });
      }
    });

    nav.addEventListener('focusout', function (event) {
      if (!nav.contains(event.relatedTarget)) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !openItem) return;
      var trigger = openItem.querySelector('[data-pw-trigger]');
      closeAll();
      if (trigger) trigger.focus();
    });

    document.addEventListener('click', function (event) {
      if (openItem && !nav.contains(event.target)) closeAll();
    });
  }

  function initDrawer(root) {
    var burger = root.querySelector('[data-pw-burger]');
    var drawer = root.querySelector('[data-pw-drawer]');
    if (!burger || !drawer || burger.dataset.pwReady) return;
    burger.dataset.pwReady = 'true';

    burger.addEventListener('click', function () {
      var open = drawer.hidden;
      drawer.hidden = !open;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-pw-nav]').forEach(initNav);
    initDrawer(scope === document ? document : scope);
  }

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  }

  /* The theme editor re-renders sections in place, which drops our listeners. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
